import {Button, Input, Space} from "antd";
import {SearchOutlined} from "@ant-design/icons";

const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
};
const handleReset = clearFilters => {
    clearFilters();
};

export const getBaseColumnSearchProps = (dataIndex, searchInput, setColumnSearch) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
        <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
            <Input
                ref={searchInput}
                placeholder={`Search ${dataIndex}`}
                value={selectedKeys[0]}
                onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                onPressEnter={() => {
                    if (setColumnSearch) {
                        setColumnSearch(dataIndex, selectedKeys[0])
                    }
                    handleSearch(selectedKeys, confirm, dataIndex)
                }}
                style={{ marginBottom: 8, display: 'block' }}
            />
            <Space>
                <Button
                    type="primary"
                    onClick={() => {
                        if (setColumnSearch) {
                            setColumnSearch(dataIndex, selectedKeys[0])
                        }
                        handleSearch(selectedKeys, confirm, dataIndex)
                    }}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{ width: 90 }}
                >
                    Search
                </Button>
                <Button
                    onClick={() => {
                        clearFilters && handleReset(clearFilters)
                        if (setColumnSearch) {
                            setColumnSearch(dataIndex, [])
                        }
                        confirm();
                    }}
                    size="small"
                    style={{ width: 90 }}
                >
                    Reset
                </Button>
                <Button
                    type="link"
                    size="small"
                    onClick={() => {
                        close();
                    }}
                >
                    Close
                </Button>
            </Space>
        </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />,
    filterDropdownProps: {
        onOpenChange(open) {
            if (open) {
                setTimeout(() => {
                    var _a;
                    return (_a = searchInput.current) === null || _a === void 0 ? void 0 : _a.select();
                }, 100);
            }
        },
    }
});

export const getColumnSearchProps = (dataIndex, searchInput, setColumnSearch) => ({
    ...getBaseColumnSearchProps(dataIndex, searchInput, setColumnSearch),
    onFilter: (value, record) => {
        if (dataIndex === "firstname") {
            const name = `${record.firstname} ${record.lastname}`;
            return name.toLowerCase().includes(value.toLowerCase());
        }
        return record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
    },
});